module.exports = __webpack_public_path__ + "static/media/stripe_button.51f57829.png";